import * as types from '../types';

// pmId: {name, defaultPw: {}, payWays, show}
const INITIAL_STATE = [];

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.PAY_METHODS_FETCHED: {
      return action.payload.reduce(
        (
          previous,
          {
            id,
            name,
            payerPrice: price,
            pwCcyAlias: currency,
            pwAlias: defaultPayWay,
          },
          index
        ) => {
          previous[id] = {
            payWays: null,
            ...(state[id] || {}),
            defaultPayWay: {
              id: defaultPayWay,
              price,
              currency,
            },
            name,
            show: true,
            order: index,
          };

          return previous;
        },
        {}
      );
    }
    case types.PAY_WAYS_FOR_PAY_METHOD_FETCHED: {
      const { id, data } = action.payload;

      return {
        ...state,
        [id]: {
          defaultPayWay: null,
          show: false,
          name: null,
          ...(state[id] || {}),
          payWays: data.map(({ alias: id, ccyAlias: currency }) => ({
            id,
            currency,
          })),
        },
      };
    }
    case types.PAY_WAY_FETCHED: {
      const {
        data: { pmId, pmName },
      } = action.payload;

      return {
        ...state,
        [pmId]: {
          defaultPayWay: null,
          payWays: null,
          show: false,
          ...(state[pmId] || {}),
          name: pmName,
        },
      };
    }
    default:
      return state;
  }
}
